<script lang="ts">
	import { Map } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';

	export let initialPointOfView: any;
	export let options: any = {};
	export let zoom: number = 4.5;
	export let noZoomControl: boolean = false;
	export let markers: any[];
	export let classNames: string;
</script>

<Map
	{initialPointOfView}
	{options}
	{zoom}
	{noZoomControl}
	{markers}
	{classNames}
	touchText={$t('maps.control.touch')}
	scrollText={$t('maps.control.scroll')}
	scrollMacText={$t('maps.control.scrollMac')}
/>
